export enum RolesEnum {
  ADMIN = 'Admin',
  MASTER = 'Master',
  STORE = 'Store',
}
